import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from 'api/client';
import { pipelineKeys } from 'api/pipelines';

// Deployment lifecycle belongs to the pipeline API. The console only needs
// this action to stop a currently executing flow.
export function useStopFlow(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiClient.post(`/api/v1/pipelines/pipelines/${id}/flow/stop/`).then((r) => r.data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: pipelineKeys.pipeline(id) });
      qc.invalidateQueries({ queryKey: pipelineKeys.runs(id) });
    },
  });
}
